export default __webpack_public_path__ + "static/challenge-1904fe1e074619fa632f6b75e553ef74.jpg";